(function () {
  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateTotal(root) {
    var checkboxes = root.querySelectorAll('.oryn-bundle__checkbox');
    var discount = parseInt(root.dataset.discount, 10) || 0;
    var total = 0;
    var fullTotal = 0;
    checkboxes.forEach(function (cb) {
      if (!cb.checked) return;
      var priceCents = parseInt(cb.dataset.priceCents, 10);
      fullTotal += priceCents;
      var itemEl = cb.closest('.oryn-bundle__item');
      var priceEl = itemEl ? itemEl.querySelector('.oryn-bundle__item-price') : null;
      if (cb.disabled) {
        // Main product is always sold at full price; only add-ons can be discounted.
        total += priceCents;
        if (priceEl) priceEl.textContent = formatPrice(priceCents);
      } else {
        var discounted = Math.round(priceCents * (1 - discount / 100));
        total += discounted;
        if (priceEl) {
          if (discount >= 100) {
            priceEl.innerHTML = '<s>' + formatPrice(priceCents) + '</s> Offert';
          } else if (discount > 0) {
            priceEl.innerHTML = '<s>' + formatPrice(priceCents) + '</s> ' + formatPrice(discounted);
          } else {
            priceEl.textContent = formatPrice(priceCents);
          }
        }
      }
    });
    var totalEl = root.querySelector('.oryn-bundle__total-price');
    if (totalEl) totalEl.textContent = formatPrice(total);

    var savingsEl = root.querySelector('[data-savings]');
    if (savingsEl) {
      var savings = fullTotal - total;
      if (savings > 0) {
        savingsEl.textContent = 'Économisez ' + formatPrice(savings);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  function refreshCartDrawer(cartDrawer) {
    return fetch('/?sections=' + cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        cartDrawer.getSectionsToRender().forEach(function (section) {
          var sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (!sectionElement || !sections[section.id]) return;
          var html = new DOMParser()
            .parseFromString(sections[section.id], 'text/html')
            .querySelector(section.selector || '.shopify-section');
          if (html) sectionElement.innerHTML = html.innerHTML;
        });
        var inner = cartDrawer.querySelector('.drawer__inner');
        if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
        cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      });
  }

  function addBundle(root) {
    var items = [];
    root.querySelectorAll('.oryn-bundle__checkbox').forEach(function (cb) {
      if (cb.checked) items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
    });
    if (items.length === 0) return;

    var btn = root.querySelector('.oryn-bundle__add');
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Ajout en cours...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          return refreshCartDrawer(cartDrawer).then(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          });
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function init() {
    document.querySelectorAll('.oryn-bundle').forEach(function (root) {
      if (root.dataset.orynBundleInit) return;
      root.dataset.orynBundleInit = 'true';
      updateTotal(root);
      root.querySelectorAll('.oryn-bundle__checkbox').forEach(function (cb) {
        cb.addEventListener('change', function () {
          updateTotal(root);
        });
      });
      var addBtn = root.querySelector('.oryn-bundle__add');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addBundle(root);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
